import styled from 'styled-components'
import theme from 'styled-theming'

import {
  COLORS,
  CSS_ELEMENTS_RESETS,
  media,
  THEME,
  transformToREM,
} from '../../styles'
import Icon from '../Icon'

const VARIANTS = {
  base: {
    background: theme('variant', {
      white: THEME.COLORS.background.secondary,
    }),
    crossFill: theme('variant', {
      white: THEME.COLORS.foreground.primary,
    }),
  },
}

const Styled = styled.div`
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 9;
  overflow-x: hidden;
  height: ${({ isOpened }) => (isOpened ? '100%' : 0)};
  transition-delay: ${({ isOpened }) => (isOpened ? 0 : '0.5s')};
  transition-property: height;
  width: 100%;
  ${media.medium`
    height: 100%;
    width: ${({ isOpened }) => (isOpened ? '100vw' : 0)};
    transition-delay: ${({ isOpened }) => (isOpened ? 0 : '0.5s')};
    transition-property: width;
  `}
`
Styled.overlay = styled.div`
  height: 100%;
  width: 100vw;
  background: ${({ isOpened }) =>
    isOpened ? THEME.COLORS.foreground.secondary : COLORS.transparent};
  transition-delay: ${({ isOpened }) => (isOpened ? 0 : '0.2s')};
  transition-duration: 0.3s;
  transition-property: background;
  padding-top: 4.4rem;
  ${media.medium`
    padding-top: 0;
  `};
`
Styled.drawerContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: ${({ maxWidth }) =>
    maxWidth ? transformToREM(maxWidth) : '90rem'};
  overflow: hidden;
  height: 100%;
`
Styled.drawer = styled.div`
  position: absolute;
  background-color: ${VARIANTS.base.background};
  margin-top: ${({ isOpened }) => (isOpened ? 0 : '100vh')};
  height: 100%;
  transition-duration: 0.3s;
  transition-property: margin-top;
  border-top-right-radius: 1.6rem;
  border-top-left-radius: 1.6rem;
  width: 100%;

  ${media.medium`
    margin-top: 0;
    position: relative;
    border-radius: 0;
    height: 100%;
    width: ${({ isOpened }) => (isOpened ? '100%' : 0)};
    transition-duration: 0.5s;
    transition-property: width;
  `};
`
Styled.drawerLayout = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  outline: none;
`
Styled.closeButton = styled.div`
  ${CSS_ELEMENTS_RESETS.button};
  position: absolute;
  right: 0.8rem;
  top: 0.8rem;
  z-index: 1;
  opacity: ${({ isOpened }) => (isOpened ? 1 : 0)};
  transition-property: opacity;
  transition-duration: 0.2s;
  transition-delay: ${({ isOpened }) => (isOpened ? 0 : '0.5s')};
  width: 4rem;
  height: 4rem;
  padding: 0.4rem;
  border-radius: 9999px;
  background-color: ${VARIANTS.base.background};
  ${media.medium`
    right: 2.4rem;
    top: 2.4rem;
  `};
`
Styled.goBackButton = styled(Styled.closeButton)`
  right: unset;
  left: 0.8rem;
`
Styled.closeIcon = styled(Icon)`
  display: block;
  width: 3.2rem;
  height: 3.2rem;

  & * {
    fill: ${VARIANTS.base.crossFill};
  }
`
Styled.goBackIcon = styled(Styled.closeIcon)``
Styled.drawerContent = styled.div`
  position: absolute;
  padding: 3.6rem 2.4rem;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
  max-width: 90rem;
  right: 0;
  opacity: ${({ isOpened }) => (isOpened ? '1' : '0')};
  transition-property: opacity;
  transition-duration: ${({ isOpened }) => (isOpened ? '0.5s' : '0.2s')};
  transition-delay: ${({ isOpened }) => (isOpened ? '0.3s' : '0')};
  ${media.medium`
    transition-delay: ${({ isOpened }) => (isOpened ? '0.5s' : '0')};
    padding: 3.6rem 2.4rem;
  `};
`

export default Styled
